export default function formatNumber(value) {
  if (value === null || value === undefined || value === '') {
    return value
  }

  const number = Number(value)
  if (Number.isNaN(number)) {
    return value
  }

  return Math.trunc(number).toLocaleString('es-CL')
}
